import { Toaster as Sonner } from "sonner";
import { useTheme } from "@/lib/theme";

/** Global toast outlet — mounted once in main.tsx. Use `notify` from `@/lib/notify`. */
export function Toaster() {
  const { resolvedTheme } = useTheme();

  return (
    <Sonner
      theme={resolvedTheme}
      position="bottom-right"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast: "font-sans text-sm",
        },
      }}
    />
  );
}
